import { useMemo } from "react";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";
import { Typography } from "./ui/typography";

const StatusSegment = ({
  isFirst,
  isLast,
  isActive,
  isError,
}: {
  isFirst?: boolean;
  isLast?: boolean;
  isActive: boolean;
  isError?: boolean;
}) => {
  const backgroundColor = useMemo(() => {
    if (isActive) {
      if (isError) {
        return "bg-stroke-negative";
      }
      return "bg-stroke-interactive";
    }
    return "bg-background-secondary";
  }, [isActive, isError]);

  return (
    <div
      className={cn(
        "h-2 w-6",
        isFirst && "rounded-l-full",
        isLast && "rounded-r-full",
        backgroundColor,
      )}
    />
  );
};

interface TransactionStatusProps {
  label?: string | null;
  progress: number;
  isError?: boolean;
}

export const TransactionStatus = ({
  label,
  progress,
  isError = false,
}: TransactionStatusProps) => (
  <Stack direction="row" align="center" gap="sm">
    <Stack direction="row" className="gap-0.5">
      <StatusSegment isFirst isActive={progress >= 1} isError={isError} />
      <StatusSegment isActive={progress >= 2} isError={isError} />
      <StatusSegment isLast isActive={progress >= 3} isError={isError} />
    </Stack>
    {label && <Typography variant="bodyW1">{label}</Typography>}
  </Stack>
);
